import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import moment from "moment";
var requests = require("@/utils/requests").default;
import TaskEditModal from "@/components/tasks/main/forms/taskEditModal";
import showUsers from "@/components/tasks/user/show_users.vue";
import attachmentMixin from "@/mixins/attachment.js";
import notificationMixin from "@/mixins/notification.js";
import { mapGetters } from "vuex";
export default {
  mixins: [notificationMixin],
  name: "ActivityListDrawer",
  components: {
    TaskEditModal: TaskEditModal,
    showUsers: showUsers,
    historyTable: function historyTable() {
      return import("@/components/tasks/activities/historyTable");
    }
  },
  computed: {
    tasksPopup: {
      get: function get() {
        return this.$store.state.tasks.popup;
      },
      set: function set(val) {
        this.$store.state.tasks.popup = val;
      }
    },
    activityDrawer: {
      get: function get() {
        return this.$store.state.app.activityDrawer;
      },
      set: function set(val) {
        this.$store.state.app.activityDrawer = val;
      }
    }
  },
  // props: {
  //   extraClass: {
  //     type: String,
  //     default: "default",
  //   },
  // },
  data: function data() {
    return {
      viewType: "notification",
      limit: 8,
      doNotDisturbVisible: false,
      doNotDisturbText: "",
      loading: false,
      noMore: false,
      mutableConfig: _objectSpread({}, this.$store.state.notification.config)
    };
  },
  created: function created() {
    this.starter();
    this.checkDoNotDisturbStatus();
  },
  methods: {
    saveConfig: function saveConfig() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ret;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("notification/setConfig", _this.mutableConfig);
            case 2:
              ret = _context.sent;
              if (ret && ret.success == true) {
                _this.doNotDisturbText = _this.$t("Saved successfully");
                setTimeout(function () {
                  _this.doNotDisturbText = "";
                  _this.doNotDisturbVisible = false;
                }, 3000);
                _this.checkDoNotDisturbStatus();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    starter: function starter() {
      var _this2 = this;
      moment.locale(this.$locale);
      this.getNotifications();
      setTimeout(function () {
        _this2.$store.dispatch("notification/setAllRead");
      }, 5000);
    },
    refresh: function refresh() {
      this.notifications = [];
      this.activities = [];
      this.count = 0;
      this.starter();
    },
    checkDate: function checkDate(i) {
      var events = this.notifications;
      var current = this.notifications[i];
      var before = this.notifications[i - 1];
      var cDate = current ? moment(current.notify_on).format("YYYY-MM-DD") : "";
      var bDate = before ? moment(before.notify_on).format("YYYY-MM-DD") : "";
      if (i != 0 && cDate == bDate) {
        return false;
      }
      return true;
    }
  }
};